import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 17204 24614"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#000;stroke-width:356.743}.fil0{fill:#1c1b17}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974598853104">
        <path
          d="M10518 8810c48 619-448 1261-1313 1613 327 1044 1635 2462 2448 2571 2447 330 3864-4406 2352-5285-978-569-1230 1137-3487 1101z"
          className="fill stroke1"
          style={{
            strokeWidth: 356.743,
          }}
        />
        <path
          d="m5016 23444 7177 11c-132-684-573-1203-1109-1470-730-365-4232-347-4902-21-566 275-995 746-1166 1480zm4759-6493c-906 100-1474 15-2324 29v3791l2001 23 323-2v-3841zm6306-8128c0-4396-3296-7671-7437-7694-4193-22-7448 3302-7519 7532-67 4026 3389 7360 7354 7434 4036 75 7602-3279 7602-7272zM4027 23940c-107-1498 1204-2875 2474-3057l-11-4137c-1939-399-3793-1911-4625-3083C-2545 7455 2455 341 7930 233c4073-517 8285 2639 8984 7024 552 3457-985 6507-3561 8299-1265 880-1399 729-2352 1119-445 182-156-34-296 231l3 3971c1883 280 2835 2613 2387 3294-214 326-487 237-974 234-1521-10-7421 137-8002-133l-92-332z"
          className="fill stroke1"
          style={{
            strokeWidth: 356.743,
          }}
        />
        <path
          d="M9775 7205c553-637 1134-2675 571-3558-1386-2177-6482-82-5487 1603 411 698 2196 473 2714 1834 1284-277 1001-400 2202 121zM7597 10263c-572-240-916-975-832-1906-1079-187-2938 328-3407 1000-1413 2024 2148 5452 3622 4511 953-609-448-1615 617-3605z"
          className="fill stroke1"
          style={{
            strokeWidth: 356.743,
          }}
        />
        <circle
          cx={8629}
          cy={8720}
          r={1023}
          className="fill stroke1"
          style={{
            stroke: "#2b2a29",
            strokeWidth: 356.743,
          }}
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
